var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.52916 5.3519C8.83079 5.63622 9.31981 5.63622 9.62144 5.3519C9.92306 5.06765 9.92306 4.60681 9.62144 4.32249L6.01791 0.926371C5.4147 0.357875 4.43659 0.357875 3.83338 0.926371L0.227708 4.3246C-0.0738973 4.60885 -0.0738973 5.06976 0.227708 5.35401C0.529313 5.63826 1.01837 5.63826 1.31997 5.35401L4.15143 2.68543L4.15143 15.7721C4.15143 16.1741 4.49722 16.5 4.92379 16.5C5.35036 16.5 5.69615 16.1741 5.69615 15.7721L5.69615 2.68201L8.52916 5.3519Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.46eb8d908e8864a24e0edaef827f6281.svg";
export { ForwardRef as ReactComponent };